module.exports = __webpack_public_path__ + "static/media/aion-promo-logo.54d72617.png";